import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Button, Typography, Alert } from 'antd';
import { GoogleOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { isLocalAuthEnabled } from '../utils/localAuth';
import './Login.css';

const { Title, Paragraph } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, isAuthenticated } = useAuth();
  const error = searchParams.get('error');
  const localAuthEnabled = isLocalAuthEnabled();

  const loginWithDifferentAccount = () => {
    const authUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/auth/google?prompt=select_account`;
    window.location.href = authUrl;
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login-page">
      <Card className="login-card">
        <div className="login-header">
          <img src="/logo.svg" alt="Mediatropy" className="login-logo" />
          <Title level={2}>Welcome Back</Title>
          <Paragraph>Sign in to manage your secure file transfers</Paragraph>
        </div>

        {error === 'auth_failed' && (
          <Alert
            message="Authentication Failed"
            description="Only @mediatropy.com email addresses are allowed to access this system."
            type="error"
            showIcon
            className="login-error"
            action={
              <Button 
                size="small" 
                type="link"
                onClick={loginWithDifferentAccount}
              >
                Try Different Account
              </Button>
            }
          />
        )}

        <Button
          type="primary"
          size="large"
          icon={localAuthEnabled ? <UserOutlined /> : <GoogleOutlined />}
          onClick={login}
          block
        >
          {localAuthEnabled ? 'Continue as Ari Joki' : 'Sign in with Google'}
        </Button>

        {error === 'auth_failed' && (
          <>
            <Button
              size="large"
              onClick={loginWithDifferentAccount}
              block
              style={{ marginTop: '12px' }}
            >
              Sign in with Different Google Account
            </Button>
            <div className="account-options">
              <a 
                href="https://accounts.google.com/Logout" 
                target="_blank" 
                rel="noopener noreferrer"
                className="google-logout-link"
              >
                Sign out of all Google accounts
              </a>
            </div>
          </>
        )}

        <div className="login-footer">
          <Paragraph type="secondary">
            Only Mediatropy team members with @mediatropy.com emails can access this system.
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};

export default Login;
